import vi from './locales/vi.json';
import { BlockType } from './types';
export const blockTypeOptions = [
  {
    label: vi.paragraph,
    value: BlockType.Paragraph,
  },
  {
    label: vi.heading + ' 1',
    value: BlockType.Heading1,
  },
  {
    label: vi.heading + ' 2',
    value: BlockType.Heading2,
  },
  {
    label: vi.heading + ' 3',
    value: BlockType.Heading3,
  },
  {
    label: vi.check,
    value: BlockType.Check,
  },
  {
    label: vi.bullet,
    value: BlockType.Bullet,
  },
  {
    label: vi.number,
    value: BlockType.Number,
  },
  {
    label: vi.quote,
    value: BlockType.Quote,
  },
];

export const colorOptions = [
  {
    label: 'Default',
    value: null,
  },
  {
    label: 'Gray',
    value: 'rgb(107 114 128)',
  },
  {
    label: 'Brown',
    value: 'rgb(159, 107, 83)',
  },
  {
    label: 'Orange',
    value: 'rgb(249 115 22)',
  },
  {
    label: 'Yellow',
    value: 'rgb(234 179 8)',
  },
  {
    label: 'Green',
    value: 'rgb(34 197 94)',
  },
  {
    label: 'Blue',
    value: 'rgb(59 130 246)',
  },
  {
    label: 'Purple',
    value: 'rgb(168 85 247)',
  },
  {
    label: 'Pink',
    value: 'rrgb(236 72 153)',
  },
  {
    label: 'Red',
    value: 'rgb(239 68 68)',
  },
];

export const backgroundColorOptions = [
  // Background
  {
    label: 'Default background',
    value: null,
  },
  {
    label: 'Gray background',
    value: 'rgb(243 244 246)',
  },
  {
    label: 'Brown background',
    value: 'rgb(236 226 217)',
  },
  {
    label: 'Orange background',
    value: 'rgb(255 237 213)',
  },
  {
    label: 'Yellow background',
    value: 'rgb(254 249 195)',
  },
  {
    label: 'Green background',
    value: 'rgb(220 252 231)',
  },
  {
    label: 'Blue background',
    value: 'rgb(219 234 254)',
  },
  {
    label: 'Purple background',
    className: 'bg-purple',
    value: 'rgb(243 232 255)',
  },
  {
    label: 'Pink background',
    className: 'bg-pink',
    value: 'rgb(252 231 243)',
  },
  {
    label: 'Red background',
    value: 'rgb(254 226 226)',
  },
];

// export const colorOptions = [
//   {
//     value: '',
//     label: 'Default',
//     className: '',
//   },
//   {
//     value: 'gray',
//     label: 'Gray',
//     className: 'text-gray',
//   },
//   {
//     value: 'brown',
//     label: 'Brown',
//     className: 'text-brown',
//   },
//   {
//     value: 'orange',
//     label: 'Orange',
//     className: 'text-orange',
//   },
//   {
//     value: 'yellow',
//     label: 'Yellow',
//     className: 'text-yellow',
//   },
//   {
//     value: 'green',
//     label: 'Green',
//     className: 'text-green',
//   },
//   {
//     value: 'blue',
//     label: 'Blue',
//     className: 'text-blue',
//   },
//   {
//     value: 'purple',
//     label: 'Purple',
//     className: 'text-purple',
//   },
//   {
//     value: 'pink',
//     label: 'Pink',
//     className: 'text-pink',
//   },
//   {
//     value: 'red',
//     label: 'Red',
//     className: 'text-red',
//   },
// ];
//
// export const backgroundColorOptions = [
//   {
//     value: '',
//     label: 'Default background',
//     className: '',
//   },
//   {
//     value: 'gray',
//     label: 'Gray background',
//     className: 'bg-gray',
//   },
//   {
//     value: 'brown',
//     label: 'Brown background',
//     className: 'bg-brown',
//   },
//   {
//     value: 'orange',
//     label: 'Orange background',
//     className: 'bg-orange',
//   },
//   {
//     value: 'yellow',
//     label: 'Yellow background',
//     className: 'bg-yellow',
//   },
//   {
//     value: 'green',
//     label: 'Green background',
//     className: 'bg-green',
//   },
//   {
//     value: 'blue',
//     label: 'Blue background',
//     className: 'bg-blue',
//   },
//   {
//     value: 'purple',
//     label: 'Purple background',
//     className: 'bg-purple',
//   },
//   {
//     value: 'pink',
//     label: 'Pink background',
//     className: 'bg-pink',
//   },
//   {
//     value: 'red',
//     label: 'Red background',
//     className: 'bg-red',
//   },
// ];
